<template>
  <div
    v-if="promoteur"
    class="l-contentmain contentmain">
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="isOwner">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <router-link :to="{ name: 'UserList'}">
            fiche de présentation
          </router-link>
        </h1>
        <div class="page-header-breadcrumb-separator" />
        <div class="page-header-breadcrumb-item">
          <span class="has-text-weight-normal has-text-grey-dark"> {{ promoteur.name }} </span>
        </div>
      </template>
      <router-link
        id="PresentationEditButton"
        slot="dropdown-content"
        :to="{name: 'PromoteurPresentationEdit'}"
        class="dropdown-item">
        <span class="icon is-medium"><i class="fas fa-user-edit" /></span>
        <span>Modifier la fiche</span>
      </router-link>
      <a
        v-if="!loading"
        slot="dropdown-content"
        class="dropdown-item"
        @click="promoteur.is_activated = !promoteur.is_activated">
        <span class="icon is-medium"><i class="fas fa-toggle-on" /></span>
        <span v-if="promoteur.is_activated">Désactiver la fiche</span>
        <span v-else>Activer la fiche</span>
      </a>
    </page-nav-bar>

    <!-- ACTIVATION BAND -->
    <spinner-round
      v-if="loading"
      :is-loading="loading" />
    <div
      v-if="(isOwner) && !loading"
      class="columns is-multiline is-padding-right-on-btn-actions is-padding-left-on-btn-actions is-minH50p is-marginless">
      <template>
        <div class="column is-12 is-border has-background-white is-paddingless">
          <div
            class="columns is-12 is-gapless is-padding-left-small is-padding-right-small is-vcentered is-minH50p is-marginless"
            :class="!promoteur.is_activated ? ' has-background-white-ter' : 'has-background-dark'">
            <div class="column is-narrow">
              <div class="is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right">
                <div>
                  <input
                    id="is_activated"
                    v-model="promoteur.is_activated"
                    class="switch is-success is-rounded"
                    type="checkbox">
                  <label
                    for="is_activated"
                    :class="!promoteur.is_activated ? '' : 'has-text-white'"
                    style="font-size: 12.5px"
                    class="is-uppercase">
                    <span
                      v-if="!promoteur.is_activated"
                      class="is-uppercase">activer la fiche de présentation</span>
                    <span v-else>désactiver la fiche de présentation</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="column is-12 is-gapless has-background-warning is-marginless"
          v-if="!promoteur.is_activated">
          <div class="is-size-7 is-padding-xxsmall">
            <span class="is-uppercase has-text-weight-bold">UNE FICHE DE PRÉSENTATION ÇA SERT À QUOI ? VOTRE FICHE PROMOTEUR
              PERMET À VOS PRESCRIPTEURS DE RETROUVER DES INFORMATIONS SUR VOTRE SOCIÉTÉ, MAIL, TÉLÉPHONE ADRESSE… <br> CETTE VUE VOUS
              PERMET DE VOUS MONTRER CE QUE VOIENT VOS PARTENAIRES.</span>
          </div>
        </div>
        <!-- PRESENTATION CARD -->
        <!-- <div
          v-if="!promoteur.is_activated"
          class="is-margin is-border">
          <div class="columns is-gapless">
            <div class="column is-4 is-padding">
              <img
                src="/img/Groupe-14893.svg"
                alt="">
            </div>
            <div class="column is-8 is-padding">
              <div class="title is-2 has-text-weight-medium is-margin-bottom-xsmall">
                Proposez un support d’information <br> qui valorise votre société auprès de vos partenaires.
              </div>
              <div class="">
                Visible par vos partenaires sur votre espace prescripteur
              </div>
              <div
                class="has-background-dark is-w64p is-margin-top-small"
                style="height: 2px;" />
              <p class="is-size-6 is-padding-top-small">
                Ne laissez plus vos partenaires prescripteur chercher l’information sur votre société.
                La fiche de présentation est personnalisable après son activation et associée à l’a fiche de vos programmes.
                Vous pouvez la personnaliser en ajoutant des photos et des textes ainsi que les coordonnées des personnes en charge de la relation avec les prescripteurs.Vous pouvez la désactiver lorsque vous le souhaitez.
              </p>
              <div class="is-margin-top">
                <a
                  :disabled="promoteur.is_activated"
                  type="button"
                  class="button is-success is-minW380p is-uppercase"
                  @click="createBuyerSpace()">
                  activer la fiche de présentation
                </a>
              </div>
            </div>
          </div>
        </div> -->
      </template>
    </div>
    <page-content
      v-if="!loading"
      :has-left-col-small="true"
      :has-left-col-small-size-fixed="false"
      :has-sticky-col-left="true">
      <!-- LEFT CONTENT -->
      <template slot="left-col-small">
        <div class="has-background-white is-border">
          <!-- LOGO -->
          <div class="has-text-centered is-padding-right-small is-padding-left-small">
            <span class="">
              <img
                v-if="promoteur.picture"
                :src="promoteur.picture.path">
              <img
                v-else
                src="/img/placeholder/image_placeholder.png"
                width="305">
            </span>
          </div>

          <div class="columns is-gapless is-vcentered is-border-bottom">
            <div class="column" />
            <div class="column is-narrow is-padding-right is-padding-bottom-xxsmall">
              <router-link
                v-if="isOwner"
                :to="{name: 'PromoteurPresentationEdit'}"
                class="is-linkTextPicto is-size-6">
                <span><i>Modifier logo</i></span> <span class="icon"><i class="fal fa-long-arrow-right" /></span>
              </router-link>
            </div>
          </div>

          <!-- INFORMATIONS -->
          <div class="is-padding-left is-padding-top-xsmall">
            <b class="has-text-primary">Nom : </b><span>{{ promoteur.name }}</span>
          </div>
          <div class="is-padding-left is-padding-right">
            <b class="has-text-primary">Adresse : </b><span v-html="address" />
          </div>
          <div class="is-padding-left is-padding-top">
            <b class="has-text-primary">Téléphone : </b><span>{{ promoteur.phone || 'NC' }}</span>
          </div>
          <div class="is-padding-left">
            <b class="has-text-primary">Site internet : </b>
            <a
              v-if="promoteur.web_site"
              class="is-linkTextPicto"
              :href="'//' + promoteur.web_site"
              target="_blank">
              <span>{{ promoteur.web_site }}</span>
            </a>
            <span v-else>NC</span>
          </div>

          <!--  SOCIAL NETWORKS  -->
          <div class="columns is-marginless">
            <div
              v-for="(media,i) in promoteur.social_media"
              :key="'media'+i"
              class="column">
              <a
                v-if="media.url"
                :href="media.url"
                target="_blank"><span class="vadPicto is-xlarge"><i :class="`fab fa-${media.label.toLowerCase()}`" /></span></a>
              <span
                v-else
                class="vadPicto is-xlarge has-text-grey-lighter"><i :class="`fab fa-${media.label.toLowerCase()}`" />
              </span>
            </div>
          </div>

          <div class="columns is-gapless is-vcentered">
            <div class="column" />
            <div class="column is-narrow is-padding-right is-padding-top-xsmall">
              <router-link
                v-if="isOwner"
                :to="{name: 'PromoteurPresentationEdit'}"
                class="is-linkTextPicto is-size-6">
                <span><i>Modifier informations</i></span> <span class="icon"><i class="fal fa-long-arrow-right" /></span>
              </router-link>
            </div>
          </div>

          <!-- PDF BROCHURE -->
          <a
            v-if="promoteur.document"
            @click="openPreview(promoteur.document)"
            class="columns is-gapless has-background-secondary is-vcentered">
            <div class="column is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
              <span class="has-text-white">Plaquette de présentation</span>
            </div>
            <div class="column is-narrow is-padding-right is-linkTextPicto is-size-6 has-text-white">
              <span class="icon">
                <i class="fal fa-long-arrow-right" />
              </span>
            </div>
          </a>
          <div
            v-else
            class="columns is-gapless has-background-secondary is-border-top" />

          <!-- REFERENT PRESCRIBER -->
          <span v-if="promoteur.referents.length">
            <div
              v-for="(referent,i) in promoteur.referents"
              :key="i"
              class="columns"
              :class="{'is-border-top' : !isFirstReferent(i)}">
              <div
                class="column is-self-centered is-radius-large has-text-centered is-4">
                <span class="vadPicto is-xlarge">
                  <img
                    class="veryFastAnimation"
                    v-if="referent.picture"
                    :src="referent.picture.cloudinary_id | avatarHeader">
                  <avatar
                    class="is-xlarge"
                    v-else-if="!referent.picture && referent.last_name && referent.first_name"
                    :item="{last_name:referent.last_name, first_name: referent.first_name}"
                    :i="i" />
                  <img
                    class="veryFastAnimation"
                    v-else
                    src="/img/placeholder/default-avatar.jpg"
                    width="92"
                    height="9240">
                </span>
              </div>
              <div class="column is-padding-right-small">
                <div class="">
                  <b class="has-text-primary">{{ referent.profession || 'Interlocuteur' }} : <br></b>
                  <span v-if="referent.last_name || referent.first_name">{{ referent.last_name }} {{ referent.first_name }}</span>
                  <span v-else>NC</span>
                </div>
                <div class="is-padding-top-xxsmall">
                  <b class="has-text-primary">Mail : </b>
                  <a
                    :href="`mailto:${referent.email}`"
                    class="is-hover-underline">{{ referent.email }}</a>
                </div>
                <div class="">
                  <b class="has-text-primary">Téléphone : </b><span>{{ referent.phone || 'NC' }}</span>
                </div>
              </div>
            </div>
          </span>

          <div
            v-if="promoteur.referents.length"
            class="columns is-gapless is-vcentered is-padding-bottom-xsmall">
            <div class="column" />
            <div class="column is-narrow is-padding-right">
              <router-link
                v-if="isOwner"
                :to="{name: 'PromoteurPresentationEdit'}"
                class="is-linkTextPicto is-size-6 is-padding-top-xsmall">
                <span><i>Modifier informations</i></span> <span class="icon"><i class="fal fa-long-arrow-right" /></span>
              </router-link>
            </div>
          </div>
        </div>
      </template>
      <!-- RIGHT CONTENT -->
      <div class="columns is-multiline">
        <div class="column">
          <div class="has-background-white is-padding-bottom-xsmall is-margin-bottom-small">
            <!-- PICTURE SLIDER -->
            <div
              v-if="promoteur.pictures"
              class="is-padding-top is-padding-bottom">
              <div class="is-relative">
                <swiper
                  v-if="promoteur.pictures.length"
                  id="mySwiper"
                  ref="awesomeSwiper"
                  :options="swiperOption"
                  class="swiper-container-pagination-top"
                  :class="{'swiper-slide-to-clicked-slide': swiperOption.slideToClickedSlide}"
                  @slideChange="slideChange">
                  <div
                    v-if="promoteur.pictures && promoteur.pictures.length > 1"
                    slot="pagination"
                    class="swiper-pagination swiper-pagination-bullet--dashed" />
                  <swiper-slide
                    v-for="(picture, idx) in promoteur.pictures"
                    :key="idx">
                    <img :src="picture.cloudinary_id | cloudinary({aspect_ratio: '16:9', crop: 'fill', quality: 70})">
                  </swiper-slide>
                </swiper>
                <swiper
                  v-else
                  id="mySwiper"
                  ref="awesomeSwiper"
                  :options="swiperOption"
                  class="swiper-container-pagination-top"
                  :class="{'swiper-slide-to-clicked-slide': swiperOption.slideToClickedSlide}"
                  @slideChange="slideChange">
                  <swiper-slide>
                    <img src="/img/placeholder/image_placeholder.png">
                  </swiper-slide>
                </swiper>
              </div>
            </div>
            <div class="columns is-gapless">
              <div class="column is-padding-right is-padding-left">
                <router-link
                  v-if="isOwner"
                  :to="{name: 'PromoteurPresentationEdit'}"
                  class="is-linkTextPicto is-size-6">
                  <span><i>Modifier diaporama d'images</i></span> <span class="icon"><i class="fal fa-long-arrow-right" /></span>
                </router-link>
              </div>
            </div>
            <!-- WYSIWIG DESCRIPTIONS -->
            <template v-if="promoteur.descriptions && promoteur.descriptions.length">
              <div
                v-for="(description, index) in promoteur.descriptions"
                :key="index"
                class="columns is-centered is-margin-top is-margin-bottom is-gapless">
                <div class="column ql-editor is-padding-right is-padding-left">
                  <h2 class="title is-1">
                    <strong v-html="description.title" />
                  </h2>
                  <!-- <h2 class="is-padding-bottom">
                    <strong v-html="description.title" />
                  </h2> -->
                  <div v-html="description.text" />
                </div>
              </div>
            </template>
            <div
              v-if="promoteur.descriptions.length"
              class="columns is-gapless">
              <div class="column is-padding-right is-padding-left">
                <router-link
                  v-if="isOwner"
                  :to="{name: 'PromoteurPresentationEdit'}"
                  class="is-linkTextPicto is-size-6">
                  <span><i>Modifier bloc texte</i></span> <span class="icon"><i class="fal fa-long-arrow-right" /></span>
                </router-link>
              </div>
            </div>
            <div
              v-if="!isOwner"
              class="columns is-gapless is-padding-bottom">
              <div class="column is-padding-right is-padding-left title">
                Vos mandats de commercialisation avec {{ promoteur.name }}
              </div>
            </div>
            <!-- PROGRAM ACCESS LIST -->
            <program-card-list
              v-if="!isOwner"
              :loading="loading"
              :source-programs="programs"
              :source-lots="lots" />
            <!-- NEW TICKET -->
            <cta-to-promoteur
              v-if="!isOwner"
              class="is-sticky--bottom is-margin-left-auto is-margin-right is-margin-top"
              @clickOnCta="openModalTicket"></cta-to-promoteur>
          </div>
        </div>
      </div>
    </page-content>
  </div>
</template>

<script>
import { DefaultValues } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import CtaToPromoteur from '@/components/utils/CtaToPromoteur'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
/** Promoteur presentation view.
 *  This view presents information about a specific promoter, identified by his pk retrieved from url parameter.
 *  It can be seen by sellers only if activated.
 */
export default {
  name: 'PromoteurPresentation',
  components: {
    ProgramCardList: () => import('../stock/ProgramCardList'),
    swiperSlide,
    swiper,
    CtaToPromoteur
  },
  mixins: [DefaultValues],
  data () {
    return {
      loading: false,
      fromComponentCreation: true,
      isActiveNotification: false,
      userAvatarHover: false,
      programs: null,
      lots: null,
      promoteur: null
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isPromoteur', 'accounts']),
    ...mapState(['currentUser']),
    isOwner () {
      return this.currentUser.account.pk === this.accountPk
    },
    /** Format address to one html line. */
    address () {
      if (this.promoteur.address.line1 && this.promoteur.address.zip_code && this.promoteur.address.city) {
        return `${this.promoteur.address.line1} <br> ${this.promoteur.address.zip_code} ${this.promoteur.address.city} ${this.promoteur.address.country || ''}`
      }
      return 'NC'
    },
    accountPk () {
      return this.$route.params.id
    },
    swiper () {
      return this.$refs.awesomeSwiper.swiper
    },
    swiperOption () {
      let options = {
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 1.10,
        centeredSlides: true,
        slideToClickedSlide: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      }
      return options
    }
  },
  watch: {
    /** Update fiche state when is_activated chagnes */
    async 'promoteur.is_activated' (value) {
      if (!this.fromComponentCreation) {
        await this.updateFicheState()
      }
    }
  },
  /** Init view by fetching data */
  async created () {
    this.loading = true
    await this.fetchFichePromoteur()
    if (!this.isOwner) {
      await this.fetchStock()
    }
    this.loading = false
    this.fromComponentCreation = false
  },
  methods: {
    /** Fetch for fiche promoteur data and append placeholder referent if necessary */
    isFirstReferent (i) {
      return i === 0
    },
    async fetchFichePromoteur () {
      try {
        const { data } = await this.$api.get(`/accounts/${this.accountPk}/promoteur-details`)
        this.promoteur = data
      } catch (e) {
        console.log(e)
      }
    },
    /** Fetch stock for sellers. By default it fetches only user accessible programs and lots */
    async fetchStock () {
      try {
        const programsResponse = await this.$api.get(this.$resources.STOCK_PROGRAM)
        const lotsResponse = await this.$api.get(this.$resources.STOCK_LOT)
        this.programs = programsResponse.data.items.filter(program => program.promoteur.pk === this.accountPk)
        this.lots = lotsResponse.data.items
      } catch (e) {
        console.log(e)
      }
    },
    /** Patch fiche state */
    async updateFicheState () {
      this.loading = true
      let payload = {
        is_activated: this.promoteur.is_activated
      }
      await this.$api.axios.patch(`/accounts/${this.accountPk}/promoteur-details`, payload)
      this.loading = false
    },
    /** Open pdf preview window */
    openPreview (selectedDocument) {
      let params = {
        link: selectedDocument.path
      }
      this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_SAAS', params })
    },
    /** Change slider active picture */
    slideChange () {
      this.$nextTick(() => {
        let current = document.querySelector('.swiper-slide-active')
        this.currentSlide = current.id
      })
    },
    /** Open contact modal */
    openModalTicket () {
      let params = {
        defaultSubject: 'other',
        defaultTitle: 'Demande d\'informations',
        promoteur: this.accountPk,
        referents: this.promoteur.referents
      }
      this.$store.commit('setModal', { mode: 'CREATE_TICKET', params })
    }
  }
}
</script>
